export default __webpack_public_path__ + "static/media/Outcome_in_allogeneic_T_cell_depleted_haplo-identi.16815b1b.pdf";